export default [
    { value: 'Um', text: '1' },
    { value: 'Dois', text: '2' },
    { value: 'Tres', text: '3' }
]